import './styles.css';

const Skills = () => {
    return (
        <div className='page-container'>
            <h1 className='page-title'>Technical Skills</h1>
            <div className='skillsColumn-container'>
                <div className='column'>
                    <h1 className='columnType-title'>Languages</h1>
                        <div className='skill-container'>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957750/Dev%20Language%20Icons/html5_lmrgt0.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957747/Dev%20Language%20Icons/css3_p0ssge.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957750/Dev%20Language%20Icons/javascript_db9xwo.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957742/Dev%20Language%20Icons/ruby_pzhglj.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <div className='icon' src='' alt='doc'/>
                            </div>
                            <div className='icon-container'>
                                <div className='icon' src='' alt='doc'/>
                            </div>
                        </div>
                </div>
                <div className='column'>
                    <h1 className='columnType-title'>Frontend</h1>
                        <div className='skill-container'>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957741/Dev%20Language%20Icons/react_xjy6ou.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957736/Dev%20Language%20Icons/tailwind_ne3bz3.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957746/Dev%20Language%20Icons/bootstrap_p7eeq8.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957743/Dev%20Language%20Icons/sass_jx4obe.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957738/Dev%20Language%20Icons/materialui_qylajm.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957742/Dev%20Language%20Icons/redux_mrfmvf.svg' alt='svg'/>
                            </div>
                        </div>
                </div>
                <div className='column'>
                    <h1 className='columnType-title'>Backend</h1>
                    <div className='skill-container'>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957743/Dev%20Language%20Icons/nodejs-1_jtj3is.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957749/Dev%20Language%20Icons/express_tvwfwe.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957742/Dev%20Language%20Icons/ruby_pzhglj.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957738/Dev%20Language%20Icons/rails-1_p4kc3n.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <div className='icon' src='' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <div className='icon' src='' alt='svg'/>
                            </div>
                        </div>
                </div>
                <div className='column'>
                    <h1 className='columnType-title'>Databases/Hosting</h1>
                    <div className='skill-container'>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957739/Dev%20Language%20Icons/postgresql_ltbseu.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957738/Dev%20Language%20Icons/mysql_cdf60q.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957738/Dev%20Language%20Icons/mongodb_ednvig.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957745/Dev%20Language%20Icons/digitalocean_ulmslp.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <div className='icon' src='' alt='doc'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615973097/Dev%20Language%20Icons/Netlify-Logo.wine_dlteet.svg' alt='svg'/>
                            </div>
                        </div>
                </div>
                <div className='column'>
                    <h1 className='columnType-title'>Tools</h1>
                    <div className='skill-container'>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615973500/Dev%20Language%20Icons/postman-logo-stacked_wgz311.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957740/Dev%20Language%20Icons/vs_code_mxps5g.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957748/Dev%20Language%20Icons/github_i7cwek.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957741/Dev%20Language%20Icons/slack-2_s1ihss.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957740/Dev%20Language%20Icons/zoom1_fyqnyr.svg' alt='svg'/>
                            </div>
                            <div className='icon-container'>
                                <img className='icon' src='https://res.cloudinary.com/gregdusek/image/upload/v1615957740/Dev%20Language%20Icons/discord_ygs0ff.svg' alt='svg'/>
                            </div>
                        </div>
                        
                </div>
            </div>
        </div>
    )
};

export default Skills;